// assets
import {
  ChromeOutlined,
  QuestionOutlined,
  AppstoreAddOutlined,
  CodepenOutlined
} from "@ant-design/icons";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";

// icons
const icons = {
  ChromeOutlined,
  QuestionOutlined,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const Masters = {
  id: "Masters",
  title: "Masters",
  type: "group",
  children: [
    {
      id: "Masters",
      title: "Masters",
      type: "collapse",
      url: "/masters",
      icon: BookmarkAddedIcon,
      children: [
        {
          id: "Masters",
          title: "Tenants",
          type: "item",
          url: "/masters/tenants",
          icon: CodepenOutlined,
        },
        {
          id: "Masters",
          title: "Pages",
          type: "item",
          url: "/masters/pages",
          icon: CodepenOutlined,
        }
      ],
    },
  ],
};

export default Masters;
